import React from 'react'
import styled from 'styled-components'
import AnchorLink from 'react-anchor-link-smooth-scroll'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 50px 5px;
  grid-auto-rows: minmax(100px, auto);
  margin-top: 100px;
  font-size: 0.8em;
  font-weight: bold;
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    font-size: 0.5em;
    grid-gap: 50px 0px;
    margin-bottom:50px;
  }
`;
const GridImage = styled.img`
  max-width: ${props => (props.src ==='./img/content/Taucher.png'?'100%':'99.5%')};
  opacity: ${props => (props.view===undefined && !props.interimsContent?0.5:1)}
`;

function NavItems(props) {
  const items = props.items || [];
  const listItems = items.map((item,i) =>
    <div key={i.toString()}>
      <AnchorLink href={"#"+item.pref.replace(/[^A-Z0-9]+/ig, "_")+item.name.replace(/[^A-Z0-9]+/ig, "_")+"_"+i.toString()}>
        <GridImage src={item.image} alt={item.name + " image"} view={item.views[0]} interimsContent={props.interimsContent} />
        {item.pref}{item.name}
      </AnchorLink>
    </div>
  );
  return (
    <Grid id="topNavi">{listItems}</Grid>
  );
}

export default class ContentNavi extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
        items: props.items,
      };
    }

  render() {
    return (
        <NavItems items={this.props.items} interimsContent={this.props.interimsContent} />
    )
  }
}
